import { createContext, type FC, type ReactNode } from 'react';

type HeaderFooterServerVarsContext = {
    buyerHost: string;
    isMobile: boolean;
    isTablet?: boolean;
    isSearchBarRedesignVariant?: boolean;
};

export const HeaderFooterServerVarsContext = createContext<HeaderFooterServerVarsContext>({
    isMobile: false,
    buyerHost: '',
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isTablet?: boolean;
    buyerHost: string;
    isSearchBarRedesignVariant?: boolean;
};

export const HeaderFooterServerVarsContextProvider: FC<Props> = ({
    children,
    buyerHost,
    isMobile,
    isTablet,
    isSearchBarRedesignVariant,
}) => (
    <HeaderFooterServerVarsContext.Provider
        value={{ buyerHost, isMobile, isTablet, isSearchBarRedesignVariant }}
    >
        {children}
    </HeaderFooterServerVarsContext.Provider>
);
